import apiBase from "@/api/unversioned/apiBase";
import { type AxiosRequestConfig } from "axios";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/risk-data/disruptions`;

const getAll = async (path: string, config?: AxiosRequestConfig) => {
  const url = `${baseURL}${path}`;
  return apiBase("get", url, {
    ...config,
    headers: {
      ...config?.headers
    }
  });
};

export default { getAll };
